
import { computed } from '@nuxtjs/composition-api';

import { usePageContent } from '@/modules/cms';
import type { ScenkonstOtPerformanceContentDataFragment } from '@/graphql/generated';

/**
 * X-Scenen custom appearence uses local colors from SCSS
 * This composable will convert graphql enum to local color
 */
export const usePerformanceCustomAppearence = () => {
  const { pageContent } = usePageContent<ScenkonstOtPerformanceContentDataFragment>();

  return {
    xScenenStyle: computed(() => {
      const { customAppearence } = pageContent.value;
      if (customAppearence?.startsWith('xstage_'))
        return customAppearence.replace('xstage_', '');

      return null;
    }),
  };
};
